// extracted by mini-css-extract-plugin
export var btn = "D_mZ x_sF x_sn d_bw d_bL d_bz d_ds";
export var full = "D_ty d_s d_D";